/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_1_Paragraphs_1Inputs */

const en_gc_search_guides_gridcraft_online_sections_1_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_1_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For a first edit, select an ordinary input cell rather than a total. Note its value, change it by a small amount and press Enter. Select a related formula cell to inspect the result. If you accidentally replace a formula, use Undo and return to the input cell.`)
};

const zh_gc_search_guides_gridcraft_online_sections_1_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_1_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首次修改时，选择普通输入单元格，而不是合计。记下原值，做小幅修改并按 Enter。再选中相关公式单元格检查结果。如果不小心覆盖公式，可以撤销，再返回输入单元格。`)
};

/**
* | output |
* | --- |
* | "For a first edit, select an ordinary input cell rather than a total. Note its value, change it by a small amount and press Enter. Select a related formula ce..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_1_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_1_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_1_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_1_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_1_paragraphs_1(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_1_paragraphs_1(inputs)
});
export { gc_search_guides_gridcraft_online_sections_1_paragraphs_1 as "gc.search_guides.gridcraft_online.sections.1.paragraphs.1" }